<template>
  <div v-if="reportLoaded">
    <v-row>
      <v-col>
        <div v-for="(customerReport, index) of report.results" :key="index">
          <route-assessment-metrics-report-card
            :customer-report="customerReport"
            :start-date="startDate"
            :end-date="endDate"
            :report-period="reportPeriod"
            :timezone="timezone"/>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RouteAssessmentMetricsReportCard from '@/components/report/route-assessment-metrics/RouteAssessmentMetricsReportCard'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ReportRecord from '@/orm/models/ReportRecord'
import { get } from 'lodash'

export default {
  name: 'RouteAssessmentMetricsReport',
  components: {
    RouteAssessmentMetricsReportCard
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    report: {
      type: ReportRecord
    }
  },
  data () {
    return {}
  },
  computed: {
    /**
     * Identifies if the report is loaded
     * @return boolean
     */
    reportLoaded () {
      return this.report && this.report.results_generated != null
    },
    /**
     * @return array
     */
    reportResults () {
      return Object.values(get(this, 'report.results') || {})
    },
    /**
     * The start date of the report.
     */
    startDate () {
      return get(this, 'report.parameters.startDate')
    },
    /**
     * The end date of the report.
     */
    endDate () {
      return get(this, 'report.parameters.endDate')
    },
    /**
     * Get the timezone that the report is operating under.
     */
    timezone () {
      return get(this.report, 'parameters.timezone')
    },
    /**
     * Get the reporting period
     */
    reportPeriod () {
      return get(this, 'report.parameters.periodInterval')
    }
  }
}
</script>

<style scoped>

</style>
